import { useQuery } from '@tanstack/react-query';

import fetchProductVersions from '../apis/fetchProductVersions';

export default function useProductVersions(productDocId) {
  return useQuery({
    queryKey: ['getProductVersions', productDocId],
    queryFn: () => fetchProductVersions(productDocId),
    enabled: !!productDocId,
    staleTime: 10 * 60 * 1000,
  });
}
